(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-countdown"] && !Shopify.designMode) return;
  try {
    

function hebrewMonthToNumber(themonth) {
    const cleanMonthName = themonth.replace('ב', '');
  switch (cleanMonthName) {
    case 'ינואר':
      return '01';
    case 'פברואר':
      return '02';
    case 'מרץ':
      return '03';
    case '׳אפר':
      return '04';
    case 'מאי':
      return '05';
    case 'יוני':
      return '06';
    case 'יולי':
      return '07';
    case 'אוגוסט':
      return '08';
    case 'ספטמבר':
      return '09';
    case 'אוקטובר':
      return '10';
    case 'נובמבר':
      return '11';
    case 'דצמבר':
      return '12';
    default:
      return null; // Invalid month name
  }
}





function parseHebrewDate(hebrewDateString) {
  console.log(hebrewDateString);
  const parts = hebrewDateString.split(' ');
  console.log(parts, "parts");
  console.log(parts[2]);
  const day = parts[1].replace(/\d{2}:\d{2}:\d{2}/, '');
// Convert day to a number
const dayNumber = parseInt(day, 10);
let newDay;
// Check if dayNumber is less than 10
if (dayNumber < 10) {
  // If it's less than 10, add a leading zero
   newDay = `0${dayNumber}`;
  console.log(newDay, "new day");
  // Now, zeroPaddedDay contains the day with a leading zero if needed
}else {
   newDay= day;
    console.log(newDay, "new day");

}
  const monthName = parts[2];
  const year = parts[3].replace(',', '');
  const time = parts[4];

  const month = hebrewMonthToNumber(monthName);
  console.log(month, "חודש");
  if (!month) {
    console.error('Invalid month name:', monthName);
    return null;
  }

  // Construct a date string in ISO 8601 format ("YYYY-MM-DDTHH:mm")
  const dateString = `${year}-${month}-${newDay}T${time}`;
  console.log(dateString,"datestring");
  return new Date(dateString);
}

document.addEventListener('DOMContentLoaded', function() {
  const countdownEndDateStr = document.getElementById("countdownEndDate").textContent;
  // Attempt to parse the Hebrew date string
  const countdownEndDate = parseHebrewDate(countdownEndDateStr);
  console.log(countdownEndDate);

  // Check if parsing was successful
  if (countdownEndDate === null || isNaN(countdownEndDate)) {
    console.error("Invalid countdown end date:", countdownEndDateStr);
    document.getElementById("countdown").innerHTML = "Invalid Date";
    return;
  }

  const updateCountdown = function() {
    const now = new Date().getTime();
    const distance = countdownEndDate - now;

    if (distance < 0) {
      clearInterval(interval);
      document.getElementById("countdown").innerHTML = "EXPIRED";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    

    const daysElement = document.getElementById("days");
const hoursElement = document.getElementById("hours");
const minutesElement = document.getElementById("minutes");
const secondsElement = document.getElementById("seconds");

// Update the content of each element
daysElement.textContent = days;
hoursElement.textContent = hours;
minutesElement.textContent = minutes;
secondsElement.textContent = seconds;
  };

  const interval = setInterval(updateCountdown, 1000);
});

document.addEventListener('DOMContentLoaded', function() {
  var wrapper = document.querySelector('.custom-countdown-wrapper');
  var desktopImage = wrapper.getAttribute('data-desktop-image');
  var mobileImage = wrapper.getAttribute('data-mobile-image');

  function updateBackgroundImage() {
    var screenWidth = window.innerWidth;
    var imageUrl = screenWidth >= 750 ? desktopImage : mobileImage;
    wrapper.style.backgroundImage = 'url(' + imageUrl + ')';
  }
console.log(desktopImage,"desktopimage");
  // Update the background image when the page loads
  updateBackgroundImage();

  // Optionally, listen for window resize events to update the background image
  window.addEventListener('resize', updateBackgroundImage);
});

    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
    class GlideSlider extends HTMLElement {
        constructor() {
            super();
            
          var col_mobile = (this.getAttribute('columns-mobile')) ? this.getAttribute('columns-mobile') : 1;
          var col_desktop = (this.getAttribute('columns-desktop')) ? this.getAttribute('columns-desktop') : 4;
          

            this.options = {
                type: 'carousel',
                startAt: 0,
                perView: col_desktop, 
                direction: 'rtl',
                gap: 10,
                breakpoints: {
                    750: {
                      perView: col_mobile
                    }
                }
            }
            
            this.init()
            
            
            
        }
        loadImagesObserver(){
            var lazyImages = [].slice.call(document.querySelectorAll('.glide img[loading="lazy"]'));
            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
              entries.forEach(function(entry) {
                  if (entry.isIntersecting) {
                      let lazyImage = entry.target;
                      lazyImage.removeAttribute("loading");
                      lazyImageObserver.unobserve(lazyImage);
                  }
              });
            });

            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        }

        init() {
            document.addEventListener("DOMContentLoaded", () => {
                let glide = new Glide('.glide', this.options);
                glide.mount(); 
                this.loadImagesObserver();
            });
        }
    }
    customElements.define('glide-slider', GlideSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') 
        return;
      



      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) 
        form.submit();
      



    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-branches"]) return;
  try {
    
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
      this.locatorActions = this.querySelector('template').content;
      this.locatorActions.select = this.locatorActions.querySelector('select');
      let optionsHtml = '';
      document.querySelectorAll('.storegroupd-title').forEach((storeGroup) => {
        optionsHtml += `<option value="${storeGroup.id}">${storeGroup.id.replace('-', ' ')}</option>`;
      });
      this.locatorActions.select.innerHTML += optionsHtml;
      document.querySelector('.shopify-section.storelocator').after(this.locatorActions);
      this.scrollContainer = document.querySelector('.page-storelocator');
      this.mql = window.matchMedia('(min-width: 750px)');
      this.locatorActions.select.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      const value = event.target.value;

      if (value) {
        location.hash = value
      }
    }
  }
  customElements.define('store-locator', StoreLocator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
